// Footer.js

function Footer () {
    return(
    <footer>
        <div className="wrapper">
            <p>Created by Connor Robock</p>
        </div>
    </footer>
    )
}

export default Footer